import React from 'react'
import { Link } from 'react-router-dom';
import me_dummy from 'D:/works/my-portfolio/src/sitting.gif'
import image1 from 'D:/works/my-portfolio/src/Frame_1.jpg'
import image2 from 'D:/works/my-portfolio/src/Frame_2.jpg'
import image3 from 'D:/works/my-portfolio/src/Frame_3.jpg'
import Navbar from './Navbar'
import Footer from './Footer'


export default function Home() {
  const styleme =
  {
    width:"700px",
    height:"300px",
    paddingTop:"100px"
  }
  return (
    <div>
     <Navbar/>
      <div className="flexrow">
        <div className="flexcolumn">
        <img src={me_dummy} alt="it me" style={styleme}></img>
        </div>
        <div className="flexcolumn">
          <h3 className='home_heading home_heading1'>SO, WHO AM I</h3>
          <div className="home_content content1">
           <p>Hi everyone! I am Jesmine. I am currently in my third year of B.Tech in Computer Science, at Vellore Institute of Technology, Chennai, India.
           I love creating things - in any form. I am hardworking and passionate about what I do, and I try to bring the best of my skills and imagination in whatever I create.
           and I am intrigued by new things which come in my way- exploring the different possibilities which come to me to figure out what I am good at.
           Afterall, we may not be the best in everything, but we can always try to be good at things we have a knack for. I would describe myself as a calm,spring day (which may be dressed up by occasional showers). Welcome to my little space on the world wide web!
          </p>
          </div>
        </div>
      </div>
      <div className="flexrow">
        <div className="flexcolumn">
        <h3 className='home_heading home_heading2'>WHAT AM I GOOD AT
        </h3>
        <div className="home_content content2">
          I love solving problems (okay, not all).I would describe myself as a creative nerd, who likes making fucntional things that also have  have a good aesthetic -I mean, first impression may not be the last but it definitely does have an impact, right?
          So yes, a full-stack developer who is also intrigued in UI/UX desining.
          Apart from that,I am fascinated by the implementation of machine learning algorithms in our day-to-day life.I have not explored much in this field yet, but I am on the run-on for the same.
          <br/><br/>
          I am good with programming languages <span className="highlight">C++ , JAVA , Python , R,  HTML</span> and <span className="highlight">PHP</span>, and frameworks <span className="highlight">React , NodeJS</span> and <span className="highlight">Streamlit</span> .I am currently exploring <span className="highlight">Flutter, Flask</span>  and experimenting with <span className="highlight">Figma</span> whenever I get the time for it (it is really fun).

          <br/><br/>
          Tech talk aside, you will find me binging on an anime, or may be on stage with a mic in my hand- but mostly
          in one corner of the room - painting (some of which, if you are interested, you will find <a href='https://in.pinterest.com/iamjesmine2001/uwu/' target='_blank'>here</a>)
        </div>
        </div>
        <div className="flexcolumn">
        <div className="containercube">
          <div className="cube">
            <div className="front"><i className="fab fa-react"></i></div>
            <div className="left"><i className="fab fa-cuttlefish">++</i></div>
            <div className="right"><i className="fab fa-node"></i></div>
            <div className="back"><i className="fab fa-js-square"></i></div>
            <div className="top"><i className="fab fa-html5"></i></div>
            <div className="bottom"><i className="fab fa-css3-alt"></i></div>
          </div>
        </div>
        </div>
      </div>
      <div className="project">
      <h3 className='home_heading home_heading3'>A LITTLE SNEAKPEEK</h3><br/>
        <div className="container">
        <a href="https://www.behance.net/gallery/164085455/E-Commerce-Website" target="_blank"><img src={image1} alt="Project 1" className="image1"/>
         <div className="text1">
          My first attempt at web development- a demo online e-commerce platform to keep up with the latest trends
         </div>
         </a>
        </div>
        <div className="container">
        <a href="https://github.com/JA-26-01/First-Today" target="_blank"  ><img src={image2} alt="Project 2" className="image2"/>
         <div className="text2">
          First Today - a news portal to let you catch up on the latest news on the go
         </div>
         </a>
        </div>
        <div className="container">
        <a href="https://github.com/JA-26-01/iNotes" target="_blank"  ><img src={image3} alt="Project 3" className="image3"/>
         <div className="text3">Jot down important notes on the go with i-Notes</div>
         </a>
        </div>
      </div>
      <Link to='/contact'><button type="button" className="hibutton">Say Hi!</button></Link>
      <Footer/>
    </div>
  )
}






       {/* <div>
          <div className='notes note1'>
          <h4>Web Stack</h4>
          <p>
            <ul>
              <li>HTML</li>
              <li>CSS</li>
              <li>JS</li>
              <li>React</li>
              <li>Node JS</li>
            </ul>
          </p>
          </div>
          <div className='notes note2'>
          <h4>Programming Languages</h4>
          <p>
            <ul>
              <li>C++</li>
              <li>JAVA</li>
              <li>C</li>
              <li>Python</li>
            </ul>
          </p>
          </div>
          <div className='notes note3'>
          <h>Others</h>
          <p>
          <ul>
              <li>Leadership</li>
              <li>Painting</li>
              <li>Oration</li>
              <li>Event Management</li>
            </ul>
          </p>
          </div>
          </div> */}



          